const fishDishes = [

    {   name: "Гаряча рибна тарілка", 
        category: 'Страви з риби', 
        unit: ' г', 
        amount: 1800, 
        price: 1650, 
        image: "/images/hariacha_rybna_tarilka.jpg",
        ingredients: '(короп, сьомга, скумбрія, креветки тигрові, імбир маринований, лимон, капуста цвітна, броколі, перець болгарський гриль, соус імбирно-часниковий, соус айолі, соус вершково-цибулевий)' 
    },

    {   name: "Сібас(філе) з різотто, шпинатом, зеленим горошком та лисичками", 
        category: 'Страви з риби', 
        unit: ' г', 
        amount: 350, 
        price: 380, 
        image: "",
        ingredients: '' 
    },

    {   name: "Скумбрія фарширована", 
        category: 'Страви з риби', 
        unit: ' г', 
        amount: 100, 
        price: 60, 
        image: "",
        ingredients: '(печериці, цибуля ріпчаста, морква, сирок плавлений, зелень, лимон)' 
    },

    {   name: "Рулет з скумбрії", 
        category: 'Страви з риби', 
        unit: ' г', 
        amount: '260/100', 
        price: 230, 
        image: "/images/rulet_z_skumbrii.jpg",
        ingredients: '' 
    },

    {   name: "Скумбрія по сицилійські", 
        category: 'Страви з риби', 
        unit: ' г', 
        amount: 220, 
        price: 280, 
        image: "/images/skumbriia_po_sytsyliisky.jpg",
        ingredients: '(скумбрія, помідори, печериці, перець болгарський, зелень)' 
    },

    {   name: "Запечений морський окунь з овочевим соте", 
        category: 'Страви з риби', 
        unit: ' г', 
        amount: 100, 
        price: 180, 
        image: "/images/Zapechenyi_morskyi_okun_z_ovochevym_sote.jpg",
        ingredients: '' 
    },

    {   name: "Філе судака смажене, в сухарях з пармезаном", 
        category: 'Страви з риби', 
        unit: ' г', 
        amount: '160/30', 
        price: 250, 
        image: "",
        ingredients: '' 
    },

    {   name: "Філе судака в кунжуті з вершково-сирним соусом", 
        category: 'Страви з риби', 
        unit: ' г', 
        amount: '180/50', 
        price: 250, 
        image: "",
        ingredients: '' 
    },

    {   name: "Філе судака з печерицями під сиром", 
        category: 'Страви з риби', 
        unit: ' г', 
        amount: 180, 
        price: 220, 
        image: "",
        ingredients: '' 
    },

    {   name: "Соте з сьомги та судака з овочами під вершковим соусом", 
        category: 'Страви з риби', 
        unit: ' г', 
        amount: 350, 
        price: 390, 
        image: "",
        ingredients: '' 
    },

    {   name: "Лосось на подушці з птитиму", 
        category: 'Страви з риби', 
        unit: ' г', 
        amount: '100/150', 
        price: 320, 
        image: "",
        ingredients: '' 
    },

    {   name: "Стейк із сьомги гриль", 
        category: 'Страви з риби', 
        unit: ' г', 
        amount: 'за 100', 
        price: 130, 
        image: "",
        ingredients: '' 
    },

    {   name: "Філе сьомги з соусом тартар гриль", 
        category: 'Страви з риби', 
        unit: ' г', 
        amount: 'за 100', 
        price: 150, 
        image: "",
        ingredients: '(сьомга, соус тартар, лимон, листя салату, зелень)' 
    },

    {   name: "Філе сьомги у вершково-ікорному соусі", 
        category: 'Страви з риби', 
        unit: ' г', 
        amount: 'за 100', 
        price: 150, 
        image: "",
        ingredients: '(сьомга, вершки, ікра червона, зелень)' 
    },

    {   name: "Форель з карамелізованим апельсином", 
        category: 'Страви з риби', 
        unit: ' г', 
        amount: 'за 100', 
        price: 76, 
        image: "",
        ingredients: '' 
    },

];

export default fishDishes;